
export default {
    name: "CustomerDetails",
    conditionData : "",
    data() {
        return {
            companyForm: {
                id: '',
                // 中文名称
                companyName: '',
                // 公司英文全称
                companyNameEn: '',
                wiffaMembertype: '',
                // 注册城市
                registryCity: '',
                // 公司注册地
                registerAddress: '',
                // 公司网站
                site: '',
                // 微信公众号
                wechatOfficalAccounts: '',
                // 公司电话
                companyTel: '',
                // 公司年营业额
                annualSalesVolume: '',
                // 年运输箱量
                annualTransportVolume: '',
                // 公司人数
                companyNos: '',
                // 公司成立日期
                companyTime: '',
                // 国际区号
                interNatCode: '',
                // 货代舱平台管理员姓名
                adminName: '',
                // 管理员手机
                adminMobile: '',
                // 管理员微信
                adminWeixin: '',
                // 服务特色
                serviceFeatures: '',
                // 业务需求
                businessRequire: '',
                // 公司法人姓名
                corporationName: '',
                // 总经理姓名
                generalManager: '',
                // 总经理电话
                generalManagerMobile: '',
                // 总经理邮箱
                generalManagerEmail: '',
                // 业务助理姓名
                assistantName: '',
                // 业务助理电话
                assistantMobile: '',
                // 业务助理邮箱
                assistantEmail: '',
                // 签章集合
                seals: []
            },
            isPreview: false,
            previewTitle : this.$t('p_sealManage.seal_preview'),
            isUpload: false,
            sealForm : {
                // 公司id
                customerId: '',
                name: '',
                sealType: '',
                fileList: [],
                dealFileList: [],
            },
            sourceFile: null,
            dealFile: null,
            isSendService : '',
            isCollectService : '',
            sealImage:''
        }
    },
    mounted: function () {
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        this.companyForm = Object.assign({}, this.companyForm, this.conditionData.row);
        this.sealForm.customerId = this.companyForm.id;
        if (this.companyForm.isSend !== 2) {
            this.isSendService = 'info';
        }
        if (this.companyForm.isReceive !== 2) {
            this.isCollectService = 'info';
        }
        console.log(this.companyForm);
    },
    computed: {
        rules() {
            return {
                name: [
                    { required: true, message: this.$t('p_sealManage.message.name'), trigger: 'blur' },
                    { max: 100, message: this.$t('p_sealManage.message.tooLong') + 100, trigger: 'blur' }
                ],
                sealType: [
                    { required: true, message: this.$t('p_sealManage.message.sealType'), trigger: 'change' },
                ],
                dealFileList: [
                    { required: true, message: this.$t('p_sealManage.message.dealFile'), trigger: 'change' }
                ],
                fileList: [
                    { required: true, message: this.$t('p_sealManage.message.file'), trigger: 'change' }
                ]
            }
        },
    },
    methods: {
        upload(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, this.sealForm);
                    delete param.fileList;
                    delete param.dealFileList;
                    param.file = this.sourceFile;
                    param.dealFile = this.dealFile;
                    const fileCheckMsg = param.file.name.substring(param.file.name.lastIndexOf('.')+1)
                    const dealFileCheckMsg = param.dealFile.name.substring(param.dealFile.name.lastIndexOf('.')+1)
                    if (param.file.size/(1024*1024) >= 2) {
                        this.$message({
                            message: this.$t('p_sealManage.message.uploadFileSize'),
                            type: 'warning',
                            center: true
                        });
                        return;
                    }

                    if (param.dealFile.size/(1024*1024) >= 2) {
                        this.$message({
                            message: this.$t('p_sealManage.message.uploadFileSize'),
                            type: 'warning',
                            center: true
                        });
                        return;
                    }
                    if (fileCheckMsg !== 'jpg' && fileCheckMsg !== 'png') {
                        this.$message({
                            message: this.$t('p_sealManage.message.uploadFileType'),
                            type: 'warning',
                            center: true
                        });
                        return;
                    }
                    if (dealFileCheckMsg !== 'jpg' && dealFileCheckMsg !== 'png') {
                        this.$message({
                            message: this.$t('p_sealManage.message.uploadFileType'),
                            type: 'warning',
                            center: true
                        });
                        return;
                    }
                    console.log(param.file)
                    console.log(param.dealFile)
                    const formData = new FormData();
                    for(let key of Object.keys(param)){
                        formData.append(key, param[key]);
                    }
                    this.$axios({
                        url: '/api/seal/sealfileupload', 
                        method: 'POST', 
                        // 请求头，发送FormData格式的数据，必须是 这种请求头。
                        headers: {  'Content-Type': 'multipart/form-data;charset=UTF-8' }, 
                        data: formData, 
                    }).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    });
                }
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        },
        // 签章预览
        preview(item) {
            this.isPreview = true;
            this.sealImage = "/api" + item.dealFile;
        },
        // 签章上传
        openUpload() {
            this.isUpload = true;
        },
        // 源文件取消删除
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.sealForm.fileList = fileList;
        },
        handlePreview(file) {
            console.log(file);
        },
        beforeRemove(file) {
            return this.$confirm(this.$t('p_sealManage.message.confirmDelFile')+` ${file.name}？`);
        },
        sourceFileChange(file, fileList) {
            this.sealForm.fileList = fileList;
            this.sourceFile = file.raw;
        },
        dealFileChange(file, dealFileList) {
            this.sealForm.dealFileList = dealFileList;
            this.dealFile = file.raw;
        },
        // 已处理文件取消删除
        dealHandleRemove(file, dealFileList) {
            console.log(file, dealFileList);
            this.sealForm.dealFileList = dealFileList;
        },
        dealHandlePreview(file) {
            console.log(file);
        },
        dealBeforeRemove(file) {
            return this.$confirm(this.$t('p_sealManage.message.confirmDelFile')+`${file.name}？`);
        },
        colseUpload() {
            this.isUpload = false;
            this.$refs.sealForm.resetFields();
        },
        handleClose() {
            this.isUpload = false;
            this.$refs.sealForm.resetFields();
        },
    }
}
